import React, { useRef, useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Componentes de preguntas
import TextQuestion from "../../components/questions/textQuestion/textQuestion";
import DropdownQuestion from "../../components/questions/dropdownQuestion/dropdownQuestion";
import RatingQuestion from "../../components/questions/ratingQuestion/ratingQuestion";

// Datos de opciones
import jobArea from "../../data/jobArea";


// APIs
import usersApi from "../../api/usersApi";
import responsesApi from "../../api/responsesApi";
import questionnaireScopeApi from "../../api/questionnaireScopeApi";

import "../../styles/hra.css";
import ABQuestion from "../../components/questions/abQuestion/abQuestion";
import ageRanges from "../../data/ageRanges";
const PAGE_SIZE = 5;

const EstresBurnout = ({ updateProgress }) => {
  const { questionnaire, idEmpresa, applicationId } = useParams();
  const navigate = useNavigate();

  const questionsRef = useRef([]);
  const [answeredState, setAnsweredState] = useState([]);
  const [answers, setAnswers] = useState({});
  const [currentPage, setCurrentPage] = useState(0);


  const [companyJobAreas, setCompanyJobAreas] = useState([]);

  useEffect(() => {
    // Obtiene la empresa/sucursal y extrae sus jobAreas
    const fetchScope = async () => {
      try {
        const scope = await questionnaireScopeApi.getById(idEmpresa);
        setCompanyJobAreas(scope.jobAreas || []);
      } catch (e) {
        console.error("Error cargando jobAreas de empresa/sucursal:", e);
      }
    };
    fetchScope();
  }, [idEmpresa]);
  // -----------------------------------------------------------
    const [companyName, setCompany] = useState([]);


    useEffect(() => {
      (async () => {
        
        try {
          const scopeResponse = await questionnaireScopeApi.getById(idEmpresa);
          setCompany(scopeResponse);
        } catch (err) {
          console.error('Error cargando empresa/sucursal:', err);
        }
      })();
    }, [idEmpresa]);
  // Decide qué conjunto de opciones usar:
  const jobAreaOptions =
    companyJobAreas.length > 0 ? companyJobAreas : jobArea;
  // Guarda respuesta y marca como respondida
  const markQuestionAsAnswered = useCallback(
    (index, field, value) => {
      setAnswers(prev => ({ ...prev, [field]: value ?? "No respondida" }));
      setAnsweredState(prev => {
        const next = [...prev];
        next[index] = true;
        return next;
      });
      updateProgress();
    },
    [updateProgress]
  );

  const handleNext = () => {
    setCurrentPage(p => Math.min(p + 1, totalPages - 1));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  const handlePrev = () => {
    setCurrentPage(p => Math.max(p - 1, 0));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

const handleSend = async () => {
  const firstUnansweredIndex = answeredState.findIndex((answered) => !answered);

  if (firstUnansweredIndex !== -1) {
    const firstUnanswered = questionsRef.current[firstUnansweredIndex];
    if (firstUnanswered) {
      firstUnanswered.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    return;
  }

  const timestamp = new Date().toISOString();
  const email = answers["email"];

  try {
    // Crear o verificar el usuario
    const userResponse = await usersApi.createFreeUser({
      username: email,
      password: "",
      role: "user",
      company: idEmpresa
    });
    const userId = userResponse.user._id;

    // Payload completo
    const completePayload = {
      userId,
      companyId: idEmpresa,
      questionnaireName: questionnaire,
      answers,
      timestamp,
      applicationId: applicationId || null,
    };

    // Enviar respuestas
    const result = await responsesApi.createEstresResponse(completePayload);
    navigate(`/estres/results`, {
      state: { response: result }
    });

  } catch (error) {
    // Capturamos el mensaje que envía el backend
    const serverMsg = error.response?.data?.message;
    if (serverMsg) {
      alert(serverMsg);
    } else {
      alert("Error enviando los datos. Intenta de nuevo más tarde.");
    }
    console.error("Error enviando los datos:", error);
  }
};

  // Lista de preguntas
  const questions = [
    { Component: TextQuestion, question: "¿Cuál es tu correo electrónico interno?", field: "email" },
    { Component: DropdownQuestion, question: "¿Cuál es tu área de trabajo?", options: jobAreaOptions, field: "jobArea" },
    { Component: ABQuestion, question: "¿Cuál es tu sexo biológico?", optionA: "Masculino", optionB: "Femenino", field: "biologicalSex" },
    { Component: DropdownQuestion, question: "¿Cuál es tu rango de edad?", options: ageRanges, field: "ageRange" },
    
    { Component: RatingQuestion, question: "Me siento emocionalmente agotado por mi trabajo.", maxRating: 7, field: "emotionalExhaustion", startsInCero: true },
    { Component: RatingQuestion, question: "Me siento acabado al final de la jornada.", maxRating: 7, field: "endOfDayFatigue", startsInCero: true },
    { Component: RatingQuestion, question: "Me siento fatigado al levantarme por la mañana y tener que enfrentarme a otro día de trabajo", maxRating: 7, field: "morningFatigue", startsInCero: true },
    { Component: RatingQuestion, question: "Trabajar todo el día realmente es estresante para mí", maxRating: 7, field: "dailyWorkStress", startsInCero: true },
    { Component: RatingQuestion, question: "Soy capaz de resolver eficazmente los problemas que surgen en mi trabajo.", maxRating: 7, field: "problemSolving", startsInCero: true },
    { Component: RatingQuestion, question: "Me siento quemado o agotado por mi trabajo", maxRating: 7, field: "burnoutFeeling", startsInCero: true },
    { Component: RatingQuestion, question: "Siento que estoy haciendo una buena contribución a la actividad de mi centro laboral", maxRating: 7, field: "workContribution", startsInCero: true },
    { Component: RatingQuestion, question: "Desde que empecé en este puesto, he ido perdiendo interés en mi trabajo", maxRating: 7, field: "lossOfInterest", startsInCero: true },
    { Component: RatingQuestion, question: "He ido perdiendo el entusiasmo en mi trabajo", maxRating: 7, field: "lossOfEnthusiasm", startsInCero: true },
    { Component: RatingQuestion, question: "En mi opinión, soy muy bueno haciendo mi trabajo", maxRating: 7, field: "selfEfficacy", startsInCero: true },
    { Component: RatingQuestion, question: "Me siento realizado cuando logro algo en mi trabajo", maxRating: 7, field: "jobFulfillment", startsInCero: true },
    { Component: RatingQuestion, question: "He realizado muchas cosas que valen la pena en mi trabajo", maxRating: 7, field: "valuableAchievements", startsInCero: true },
    { Component: RatingQuestion, question: "Me he vuelto más cínico y pesimista en mi trabajo", maxRating: 7, field: "cinicWork", startsInCero: true },
    { Component: RatingQuestion, question: "Dudo de la importancia de mi trabajo", maxRating: 7, field: "doubtWorkImportance", startsInCero: true },
    { Component: RatingQuestion, question: "En mi trabajo estoy seguro de que soy eficaz haciendo las cosas.", maxRating: 7, field: "confidenceInEffectiveness", startsInCero: true },
  
    { Component: RatingQuestion, question: "Imposibilidad de conciliar el sueño.", maxRating: 7, field: "insomnia", startsInCero: true },
    { Component: RatingQuestion, question: "Jaquecas y dolores de cabeza.", maxRating: 7, field: "headaches", startsInCero: true },
    { Component: RatingQuestion, question: "Indigestiones o molestias gastrointestinales", maxRating: 7, field: "gastrointestinalIssues", startsInCero: true },
    { Component: RatingQuestion, question: "Sensación de cansancio extremo o agotamiento.", maxRating: 7, field: "extremeTiredness", startsInCero: true },
    { Component: RatingQuestion, question: "Tendencia de comer, beber o fumar más de lo habitual.", maxRating: 7, field: "increasedConsumption", startsInCero: true },
    { Component: RatingQuestion, question: "Disminución del interés sexual.", maxRating: 7, field: "lowSexDrive", startsInCero: true },
    { Component: RatingQuestion, question: "Respiración entrecortada o sensación de ahogo.", maxRating: 7, field: "shortnessOfBreath", startsInCero: true },
    { Component: RatingQuestion, question: "Disminución del apetito.", maxRating: 7, field: "lossOfAppetite", startsInCero: true },
    { Component: RatingQuestion, question: "Temblores musculares (por ejemplo tics nerviosos o parpadeos).", maxRating: 7, field: "muscleTremors", startsInCero: true },
    { Component: RatingQuestion, question: "Pinchazos o sensaciones dolorosas en distintas partes del cuerpo.", maxRating: 7, field: "bodyPains", startsInCero: true },
    { Component: RatingQuestion, question: "Tentaciones fuertes de no levantarse por la mañana.", maxRating: 7, field: "morningAvoidance", startsInCero: true },
    { Component: RatingQuestion, question: "Tendencias a sudar o palpitaciones.", maxRating: 7, field: "sweatingPalpitations", startsInCero: true },
  ];

  // Sincroniza refs/estado con el número real de preguntas
  useEffect(() => {
    questionsRef.current = questionsRef.current.slice(0, questions.length);
    setAnsweredState((prev) => {
      const next = new Array(questions.length).fill(false);
      prev.forEach((value, idx) => {
        if (idx < next.length && value) next[idx] = true;
      });
      return next;
    });
  }, [questions.length]);

  const totalPages = Math.ceil(questions.length / PAGE_SIZE);
  const start = currentPage * PAGE_SIZE;
  const pageQuestions = questions.slice(start, start + PAGE_SIZE);
  const progressPct = Math.round(((currentPage + 1) / totalPages) * 100);
  const isPageComplete = answeredState
  .slice(start, start + PAGE_SIZE)     // toma sólo las preguntas de esta página
  .every(answered => answered === true);
  return (
    <div className="questionnaire-container">
      <h2>Cuestionario de Estrés y Burnout</h2>
      <p>Empresa: {companyName.name}</p>
      <p>Lea cuidadosamente cada enunciado y marque los casilleros correspondientes a la frecuencia de sus sentimientos acerca del trabajo donde labora. Las opciones que puede marcar son</p>
      <p>0=Nunca/Ninguna vez.</p>
      <p>1 Casi nunca/ Pocas veces al año.</p>
      <p>2= Algunas veces / Una vez al mes o menos.</p>
      <p>3 = Regularmente / Pocas veces al mes.</p>
      <p>4 Bastantes veces / Una vez por semana.</p>
      <p>5 Casi siempre / Pocas veces por semana.</p>
      <p>6 = Siempre / Todos los días.</p>

      <div
        className="progress-fill"
        style={{ width: `${progressPct}%` }}
      />
      <p className="progress-text">Página {currentPage + 1} de {totalPages}</p>

      {pageQuestions.map((q, idx) => {
        const globalIdx = start + idx;
        const QuestionComp = q.Component;

        return (
          <div
            key={globalIdx}
            ref={el => (questionsRef.current[globalIdx] = el)}
            className="question-card"
          >
            <QuestionComp
              question={q.question}
              required
              type={q.type}
              options={q.options}
              optionA={q.optionA}
              optionB={q.optionB}
              followUp={q.followUp}
              maxRating={q.maxRating}
              hourRange={q.hourRange}
              startsInCero={q.startsInCero}
              uniqueChoice={q.uniqueChoice}
              value={answers[q.field] ?? ""}
              updateProgress={val => markQuestionAsAnswered(globalIdx, q.field, val)}
            />
          </div>
        );
      })}

      <div className="pagination">
        {currentPage > 0 && (
          <button onClick={handlePrev} className="page-button">
            Anterior
          </button>
        )}
        {currentPage < totalPages - 1 ? (
          <button
          onClick={handleNext}
          className="page-button"
          disabled={!isPageComplete}         // acá deshabilitas hasta que la página esté completa
        >
            Siguiente
          </button>
          
        ) : (
          <button onClick={handleSend} className="page-button submit-button">
            Enviar
          </button>
        )}
      </div>
    </div>
  );
};
export default EstresBurnout;
